import $ from "jquery";

class GifExport {

    init() {
        // Only initialize on pages/frames that actually contain the GIF export form
        this.form = $('#export_gif_form')
        if (this.form.length === 0) {
            return
        }

        this.action = this.form.attr('action')

        // Data coming from hidden fields in the form
        this.rpm = this.form.find('#export_gif_rpm')
        this.size = this.form.find('#export_gif_size')
        this.background = this.form.find('[name=export_gif_background_color]')
        this.uuid = this.form.find('[name=variant_uuid]').val()
        this.base_url = this.form.find('[name=base_url]').val() || ''
        const sourceImagesRaw = this.form.find('[name=source_images]').val() || '[]'
        try {
            this.source_images = JSON.parse(sourceImagesRaw)
        } catch(e) {
            console.warn('[GifExport] Failed to parse source_images JSON', e, sourceImagesRaw)
            this.source_images = []
        }
        const imageCountRaw = this.form.find('[name=image_count]').val()
        this.image_count = parseInt(imageCountRaw || this.source_images.length || 0, 10) || 0
        const aspectRatioRaw = this.form.find('[name=aspect_ratio]').val()
        this.aspect_ratio = parseFloat(aspectRatioRaw || '1') || 1
        const reverseSpinRaw = this.form.find('[name=reverse_spin]').val()
        this.reverse_spin = (reverseSpinRaw === 'true' || reverseSpinRaw === '1')

        this.button = this.form.find('button')

        this.isExporting = false

        this.init_sliders()
        this.init_panel()
        this.init_form()
        this.init_button()
    }

    init_sliders() {
        const that = this

        this.adjust_size(this.size.val())

        // Initialize size slider
        $('#export_gif_size_slider').on('input', function() {
            that.adjust_size(this.value)
        }).on('change', function() {
            that.adjust_size(this.value)
            that.size.trigger('change')
        })

        this.adjust_rpm(that.rpm.val())

        // Initialize RPM slider
        $('#export_gif_rpm_slider').on('input', function() {
            that.adjust_rpm(this.value)
        }).on('change', function() {
            that.adjust_rpm(this.value)
            that.rpm.trigger('change')
        })
    }

    init_panel() {
        if (typeof window.store_viewer_settings === 'function') {
            window.store_viewer_settings()
        }

        // Disable relevant viewer features for GIF preview
        const viewerInstance = window.viewer();
        if (viewerInstance) {
            viewerInstance.zoom(false)
            if (viewerInstance.settings && viewerInstance.settings.fullscreen) {
                viewerInstance.fullscreen(false)
            }
            viewerInstance.manual_spin(false)
            viewerInstance.auto_spin(true)
            viewerInstance.auto_spin_count(1000000)

            const background = parseAndValidateColor(this.background.val())
            viewerInstance.background_color(background)

            const rpm = parseInt(this.rpm.val())
            viewerInstance.auto_spin_speed(rpm)
        }
    }

    init_form() {
        const that = this

        // Initialize HTML5 color picker
        const colorPicker = $('#export_gif_color_picker');
        if (colorPicker.length > 0) {
            // Sync color picker with text field
            colorPicker.on('change', function() {
                const color = this.value;
                // Remove # prefix for text field (since we have input group with #)
                const hexValue = color.startsWith('#') ? color.substring(1) : color;
                that.background.val(hexValue);
                that.background.trigger('blur');
            });

            // Sync text field with color picker
            this.background.on('input', function() {
                const color = this.value;
                // Check if it's a valid hex color (without # since we have input group)
                if (color && color !== 'transparent' && /^[a-fA-F0-9]{6}$/.test(color)) {
                    // Add # prefix for color picker
                    const hexColor = '#' + color;
                    colorPicker.val(hexColor);
                }
            });
        }

        this.rpm.on('change', function () {
            const rpm = parseInt(that.rpm.val())
            const viewerInstance = window.viewer();
            if (viewerInstance) {
                viewerInstance.auto_spin_speed(rpm)
            }
        })

        this.background.on('blur', function () {
            // Add # prefix to the hex value for validation
            const hexWithHash = this.value.startsWith('#') ? this.value : '#' + this.value
            const value = parseAndValidateColor(hexWithHash)
            // Keep only the hex value (without #) for display since we have input group
            const displayValue = value === 'transparent' ? value : value
            this.value = displayValue
            that.background.val(displayValue)
            const viewerInstance = window.viewer();
            if (viewerInstance) {
                viewerInstance.background_color(value)
            }
        })
    }


    init_button() {
        const that = this
        this.button.on('click', function () {
            if (that.isExporting) {
                return
            }
            that.isExporting = true
            that.button.prop('disabled', true)

            that.export()
        })
    }

    export() {
        const that = this
        const size = parseInt(this.size.val())

        let width, height
        if (this.aspect_ratio < 1) {
            width = size
            height = Math.round(size * this.aspect_ratio)
        } else {
            width = Math.round(size / this.aspect_ratio);
            height = size
        }
        that.width = width
        that.height = height

        that.backgroundColor = parseAndValidateColor(this.background.val())

        const rpm = parseInt(this.rpm.val())

        // Store GIF export form values
        $.ajax({
            type: 'PATCH',
            url: this.action,
            data: {
                project: {
                    exported_gif_size: size,
                    exported_gif_rpm: rpm,
                    exported_gif_background_color: that.backgroundColor,
                }
            },
            dataType: 'JSON'
        })


        let rps = rpm / 60.0
        let fps = rps * this.image_count
        let minimum_delay = 50.0
        let max_fps = 1000 / minimum_delay // 20fps
        let ordials

        if (this.reverse_spin) {
            ordials = __range__(this.image_count, 1, true)
        } else {
            ordials = __range__(1, this.image_count, true)
        }

        // Reduce number of source images if max FPS is exceeded
        if (fps > max_fps) {
            let factor = Math.ceil(fps / (max_fps * 1.0));
            const reduced_ordials = ((() => {
                const result = []
                for (let step = factor, asc = step > 0.0, i = asc ? 0.0 : ordials.length - 1; asc ? i < ordials.length : i >= 0; i += step) {
                    const ordial = ordials[i]
                    result.push(ordial)
                }
                return result
            })())

            reduced_ordials.pop()
            ordials = reduced_ordials
            fps = max_fps
        }

        const delay = Math.ceil(1000 / fps)

        // GIF export
        const gif = new GIF({
            workers: 2,
            quality: 10,
            repeat: 0,
            width: width,
            height: height,
            workerScript: "/javascripts/gif.worker.js"
        })

        gif.on('progress', function (progress) {
            that.setProgress(progress, 1, "Processing")
        })

        // Download GIF
        gif.on('finished', function (blob) {
            that.done(blob)
        })

        this.loadImages(ordials, function () {
            // Load images into GIF
            for (let image of that.images) {
                // Add frame
                gif.addFrame(image, {delay})
            }

            // Render
            gif.render()
        })
    }

    loadImages(ordials, callback) {
        let that = this
        let loaded = 0
        this.images = []
        for (let ordial in ordials) {
            const img = new Image()
            img.src = `${that.base_url}${that.source_images[ordial]}/resize;w_${that.width};h_${that.height}/optimize;bg_${that.backgroundColor}/image.jpg`
            img.crossOrigin = "Anonymous"
            img.width = that.width
            img.height = that.height
            img.ordial = ordial
            that.images.push(img)

            img.onload = function () {
                loaded++
                that.setProgress(loaded, ordials.length, "Loading")
                if (loaded === ordials.length) {
                    callback()
                }
            }
        }
    }

    adjust_size(value) {
        this.size.val(value)
        if (this.aspect_ratio < 1) {
            return $('#export_gif_size_display').val(`${value} x ${Math.round(value * this.aspect_ratio)}`);
        } else {
            return $('#export_gif_size_display').val(`${Math.round(value / this.aspect_ratio)} x ${value}`);
        }
    }

    adjust_rpm(value) {
        this.rpm.val(value)
        $('#export_gif_rpm_display').val(`${value}`)
    }

    setProgress(value, total, label) {
        const percent = Math.round(value / total * 100)
        this.button.text(`${label}: ${percent}%`)
        this.button.css({background: `linear-gradient(90deg, #003595 0%, #003595 ${percent}%, #0069d9 ${percent}%, #0069d9 100%)`})
    }

    done(blob) {
        const url = URL.createObjectURL(blob)
        const download = $('<a>')
        download.appendTo($('body'))
        download.attr('href', url)
        download.attr('download', "animated.gif")
        download[0].click()
        window.URL.revokeObjectURL(url)
        download.remove()

        // reset button
        this.button.prop('disabled', false)
        this.button.css({background: ""})
        this.button.text("Export")

        // unblock export process
        this.isExporting = false
    }
}

function __range__(left, right, inclusive) {
    let range = [];
    let ascending = left < right;
    let end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
        range.push(i);
    }
    return range;
}
// Export the class for Stimulus controllers / tests
export { GifExport };